import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_BASE_URL = 'https://indianfooddelight.com';
const DEFAULT_IMAGE = `${SITE_BASE_URL}/home-food.jpg`;

function Seo({
  title,
  description,
  path,
  robots = 'index,follow',
  image = DEFAULT_IMAGE,
  type = 'website',
}) {
  const normalizedPath = path
    ? path.startsWith('/')
      ? path
      : `/${path}`
    : '/';
  const canonicalPath = normalizedPath.length > 1
    ? normalizedPath.replace(/\/+$/, '')
    : normalizedPath;
  const canonicalUrl = `${SITE_BASE_URL}${canonicalPath}`;

  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Indian Food Delight" />
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}
    </Helmet>
  );
}

export default Seo;
